var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',_vm._l((_vm.nodes),function(node){return _c('l-form-row',{key:node.data,attrs:{"choices":_vm.buildChoices(node),"onchange":_vm.updateChoice,"type":_vm.getType(node)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }